import React from "react";
const ErrorMessage: React.FC = () => {
  return (
    <div className="w-full h-screen flex flex-col justify-center text-primary items-center text-center mx-auto max-w-xl">
      <p className="text-4xl mb-4">
        Oops! You've encountered an error. Please try reloading the page
      </p>
      <button
        className="text-2xl mt-5 py-[1.3rem] px-[6rem] text-black rounded-[5px_27px_19px_25px] bg-cover bg-no-repeat bg-[url('@assets/images/btnBgImage.webp')] duration-150 hover:scale-95"
        onClick={() => window.location.reload()}
        aria-label="Reload page"
      >
        Reload page
      </button>
    </div>
  );
};

export default ErrorMessage;
